import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as PaymentsActions } from "store/ducks/payments";

import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Points/Payments/components";

class Create extends Component {
  state = {
    form: {
      external_id: "",
      name: "",
      type_payment: "",
      description: "",
      score: true,
    },

    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "/points" },
      { name: "Métodos de Pagamento", to: "/points/payments" },
      { name: "Novo", to: "" },
    ],
  };

  handleChange = (data) => {
    this.setState({ form: data });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { form } = this.state;

    this.props.createPaymentRequest({
      payment_method: {
        ...form,
        type_payment: form.type_payment === "" ? null : form.type_payment,
      },
    });
  };

  render() {
    const { form, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={form}
          saving={create.loading}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  create: state.payments.create,
});

const mapActions = (dispatch) => bindActionCreators(PaymentsActions, dispatch);

export default connect(mapState, mapActions)(Create);
